import { Droplets } from "lucide-react";
import { getBaptismRecords } from "@/lib/api";

const baptismsProvider = {
  id: "bautismos",
  label: "Bautismos",
  icon: Droplets,
  iconBg: "bg-cyan-50",
  iconColor: "text-cyan-600",
  fields: ["person_name", "notes"],
  load: async (districtId) => {
    const records = await getBaptismRecords({ district_id: districtId });
    // Flatten person name so the search index can match on it
    return records.map((b) => ({
      ...b,
      person_name: b.people?.name || "",
    }));
  },
  buildItem: (b) => ({
    id: b.id,
    title: b.person_name || "Persona bautizada",
    subtitle: b.baptism_date || "Bautismo",
    route: b.person_id ? `/people/${b.person_id}` : "/baptisms",
    recent: null,
  }),
};

export default baptismsProvider;
